const t = (x, y, w, h, text, fontSize, color, fontWeight = 600, extra = {}) => ({
  id: `${x}-${y}-${text}`, type: "text", x, y, w, h, text, fontSize, color, fontWeight,
  align: "left", fontFamily: "Plus Jakarta Sans", lineHeight: 1.15, ...extra,
});
const r = (x, y, w, h, fill, extra = {}) => ({ id: `r${x}-${y}-${w}`, type: "rect", x, y, w, h, fill, ...extra });

export const PREVIEW_TPL = {
  jewel: {
    width: 85.6, height: 54,
    front: {
      background: "linear-gradient(135deg,#FFFBEB 0%,#FEF3C7 50%,#FFFBEB 100%)",
      elements: [
        r(1.5, 1.5, 82.6, 51, "transparent", { stroke: "#B8860B", strokeWidth: 0.6, radius: 1.5 }),
        t(5, 5, 75.6, 5, "ROYAL GEMS & JEWELLERS", 8.5, "#78350F", 800, { align: "center", fontFamily: "Cinzel" }),
        t(5, 11, 75.6, 4, "CERTIFICATE OF AUTHENTICITY", 5, "#B8860B", 700, { align: "center", letterSpacing: 2 }),
        t(8, 20, 30, 3, "CERT NO", 4, "#92400E"), t(32, 20, 40, 3, "{{c}}", 5, "#1C1917", 700, { fontFamily: "JetBrains Mono" }),
        t(8, 25, 30, 3, "ITEM", 4, "#92400E"), t(32, 25, 40, 3, "{{i}}", 5, "#1C1917", 700),
        t(8, 30, 30, 3, "PURITY", 4, "#92400E"), t(32, 30, 40, 3, "{{p}}", 5, "#1C1917", 700),
        t(8, 35, 30, 3, "DIAMOND", 4, "#92400E"), t(32, 35, 40, 3, "{{d}}", 5, "#1C1917", 700),
        { id: "q", type: "qr", x: 66, y: 36, w: 13, h: 13, value: "https://example.com/verify", color: "#1C1917", bg: "#FFFBEB" },
      ],
    },
  },
  jewelData: { c: "JWC-2026-8891", i: "Solitaire Diamond Ring", p: "18K Gold · 750", d: "1.20 ct · VVS1 / EF" },
  id: {
    width: 85.6, height: 54,
    front: {
      background: "#1C1917",
      elements: [
        r(1.5, 1.5, 82.6, 51, "transparent", { stroke: "#D4A017", strokeWidth: 0.5, radius: 1.5 }),
        { id: "seal", type: "ellipse", x: 34.8, y: 6, w: 16, h: 16, fill: "transparent", stroke: "#D4A017", strokeWidth: 0.6 },
        t(34.8, 11.5, 16, 5, "916", 9, "#FDE68A", 800, { align: "center" }),
        t(6, 26, 73.6, 4, "BIS HALLMARKED · CERTIFIED NATURAL DIAMONDS", 5, "#FDE68A", 700, { align: "center", letterSpacing: 1 }),
        t(6, 33, 73.6, 4, "{{n}}", 6, "#D6D3D1", 500, { align: "center" }),
        t(6, 43, 73.6, 4, "{{e}}", 5, "#A8A29E", 500, { align: "center", fontFamily: "JetBrains Mono" }),
      ],
    },
  },
  idData: { n: "Owner: Ananya Mehta", e: "JWC-2026-00042" },
};
